<script lang="ts" setup>
import { ToccoItem } from '~/api/drupal'

defineProps<{
  title: string
  items: ToccoItem[]
}>()
</script>

<template>
  <SectionSpecial :title="title">
    <LinkListLarge>
      <template #default="{ isHovered }">
        <ToccoEventTeaser
          v-for="item in items"
          :key="item.id"
          v-animate="{ animation: 'vertical-reveal' }"
          v-bind="item"
          :dim="isHovered"
        />
      </template>
    </LinkListLarge>
  </SectionSpecial>
</template>
